import{ useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@app/store";
import { fetchTechinicals, deleteTechinical } from "./TechinicalSlice";
import DataTable from "@components/ui/DataTable";
import type { Column } from "@components/ui/DataTable";
import { TechinicalOutputDTO } from "./types";
import { LoadingSkeleton } from "@components/ui/LoadingSkeleton";
import { ErrorDisplay } from "@components/ui/ErrorDisplay";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { fetchAffiliates } from "../affiliate/AffiliateSlice";
import { fetchCategoryDocuments } from "../categorydocument";
import { Article } from "@mui/icons-material";
import { IconRight } from "react-day-picker";
import ApplyTags from "./ApplyTags";

const TechinicalList = (props: any) => {
  console.log("🔄 Renderizando TechinicalList");
  const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();
  const { items, loading, error } = useSelector((state: RootState) => {
    console.log("🔍 Selector executando, loading:", state.techinical.loading);
    return state.techinical;
  });

  const {
    items: categories,
    loading: loading_categories,
    error: error_categories,
  } = useSelector((state: RootState) => {
    console.log(
      "🔍 Selector executando, loading:",
      state.categorydocument.loading
    );
    return state.categorydocument;
  });

  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [filters, setFilters] = useState<Record<string, string>>({});
  const [modal, setModal] = useState(false);
  const [tecnical, setTecnical] = useState(null);


  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const isLoadingRef = useRef(false);
  const initialLoadDoneRef = useRef(false);
  // const [sector, setSector] = useState("");
  // const [profile, setProfile] = useState("");

  // const { items: affiliates, loading: affiliatesLoading } = useSelector(
  //     (state: RootState) => state.affiliate
  //   );

  const loadData = useCallback(
    async (currentFilters: Record<string, string>) => {
      // Avoid simultaneous calls
      if (isLoadingRef.current) {
        console.log("🚫 Requisição em andamento, ignorando nova chamada");
        return;
      }

      // Avoid calls after initial load
      // if (initialLoadDoneRef.current && Object.keys(currentFilters).length === 0) {
      //   console.log('🚫 Ignorando chamada sem filtros após carregamento inicial');
      //   return;
      // }
      await dispatch(fetchCategoryDocuments({}));

      console.log("📡 Iniciando requisição fetchTechinicals");
      isLoadingRef.current = true;

      try {
        await dispatch(fetchTechinicals(currentFilters));
        await dispatch(fetchAffiliates({}));

        initialLoadDoneRef.current = true;
      } finally {
        isLoadingRef.current = false;
      }
    },
    [dispatch]
  );

  useEffect(() => {
    console.log("🔄 useEffect - Carregando dados iniciais");
    loadData(filters);
    setIsInitialLoad(false);
  }, [loadData, filters]);

  useEffect(() => {
    if (props.setTotal) {
      props.setTotal(items?.length);
    }
  }, [items]);

  const handleFilterChange = (newFilters: Record<string, string>) => {
    console.log("🔍 Filtros alterados:", newFilters);
    setFilters(newFilters);
  };

  const handleDelete = async (id: string) => {
    setDeleteId(id);
  };

  const confirmDelete = async () => {
    if (deleteId) {
      await dispatch(deleteTechinical(deleteId));
      setDeleteId(null);
      loadData(filters);
    }
  };

  const cancelDelete = () => {
    setDeleteId(null);
  };

  const columns: Column<TechinicalOutputDTO>[] = [
    {
      image: "photoUrl",
      placeholderImage: "./documents.svg",
      style_image: {
        borderRadius: 10,
        border: "1px solid lightgrey",
        background: "rgb(244, 244, 244)",
        width: 30,
        height: 30,
        objectFit: "contain",
      },

      key: "name" as keyof TechinicalOutputDTO,
      header: "Nome",
      render: (value: any) => String(value || ""),
    },
    {
      key: "category",
      header: "Categoria",
      render: (value: any) => {
        return (
          categories.filter((item: any) => item._id == value)[0]?.name ?? ""
        );
        // String(value || '')
      },
    },
    // {
    //   key: 'email' as keyof TechinicalOutputDTO,
    //   header: 'Email',
    //   render: (value: any) => String(value || ''),
    // },

    // {
    //   key: 'createdAt' as keyof TechinicalOutputDTO,
    //   header: 'Data de Criação',
    //   render: (value: any) => value ? new Date(value as Date).toLocaleDateString() : '-',
    // },
  ];

  const filterFields = [
    {
      name: "name",
      label: "Nome",
      type: "text",
    },
    {
      name: "email",
      label: "Email",
      type: "text",
    },
  ];

  if (loading && isInitialLoad) {
    return <LoadingSkeleton />;
  }

  if (error) {
    return <ErrorDisplay error={error} />;
  }

  console.log(props.hide_header);

  return (
    <div
      className={
        "flex flex-col flex-1 shrink  self-stretch  basis-0 min-w-60 max-md:px-5 bg-background-dark " +
        (props.hide_header != true ? " px-6 py-7" : "")
      }
    >
      {/* <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Colaboradores</h1>
        
      </div> */}

      {/* Temporarily commenting out DataFilter until we fix its interface */}
      {/* <DataFilter fields={filterFields} onFilterChange={handleFilterChange} /> */}

      <DataTable
        hide_header={props.hide_header}
        columns={columns}
        data={items}
        title={"Peças técnicas"}
        subtitle={"Lista das peças técnicas cadatrados no sistema"}
        basePath="techinicals-documents"
        onDelete={handleDelete}
        loading={loading}
        error={error}
        newFormat
        hide_show

        actions={[
          {
            label: "Configurar Tags",
            icon: <Article />,
            onClick: (item: TechinicalOutputDTO) => {
              navigate(`/techinicals-documents/generate/${item._id}`);
            },
          },
          {
            label: "Gerar Documento",
            icon: <IconRight />,
            onClick: (item: TechinicalOutputDTO) => {
              setTecnical(item);
              setModal(true)
              // navigate(`/techinicals-documents/generate/${item._id}`);
            },
          },
        ]}
      />
      {modal && <ApplyTags tecnical={tecnical} isOpen={modal}  onClose={(e)=>setModal(false)}  />}

      <Dialog open={!!deleteId} onClose={cancelDelete}>
        <DialogTitle>Confirmar Exclusão</DialogTitle>
        <DialogContent>
          <Typography>
            Tem certeza que deseja excluir esta peça técnica? Esta ação não pode
            ser desfeita.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelDelete} color="primary">
            Cancelar
          </Button>
          <Button onClick={confirmDelete} color="error">
            Excluir
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TechinicalList;